(() => {
      document.documentElement.dataset.pocketLightJs = 'loaded';
      function initPocketLight() {
      const root = document.querySelector('[data-pocket-light]');
      if (!root) return;
      root.dataset.pocketLightInitialized = 'true';
      const options = Array.from(root.querySelectorAll('[data-variant-option]'));
      const forms = Array.from(root.querySelectorAll('[data-product-form]'));
      const priceNodes = Array.from(root.querySelectorAll('[data-selected-price]'));
      const titleNodes = Array.from(root.querySelectorAll('[data-selected-title]'));
      const helperNodes = Array.from(root.querySelectorAll('[data-selected-helper]'));
      const stockNodes = Array.from(root.querySelectorAll('[data-selected-stock]'));
      const buyButtons = Array.from(root.querySelectorAll('[data-buy-button]'));
      const heroImage = root.querySelector('[data-selected-image]');
      const mainForm = root.querySelector('[data-product-form="main"]');

      function selectVariant(button) {
        options.forEach((option) => option.setAttribute('aria-pressed', option === button ? 'true' : 'false'));
        const id = button.dataset.variantId;
        const price = button.dataset.variantPrice;
        const title = button.dataset.variantTitle;
        const helper = button.dataset.variantHelper;
        const available = button.dataset.variantAvailable === 'true';
        forms.forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          if (input) input.value = id;
        });
        priceNodes.forEach((node) => { node.textContent = price; });
        titleNodes.forEach((node) => { node.textContent = title; });
        helperNodes.forEach((node) => { node.textContent = helper; });
        stockNodes.forEach((node) => { node.textContent = available ? 'In stock' : 'Currently unavailable'; });
        buyButtons.forEach((buttonNode) => {
          buttonNode.disabled = !available;
          if (buttonNode.hasAttribute('data-dynamic-label')) buttonNode.textContent = available ? `Add to cart · ${price}` : 'Currently unavailable';
        });
        if (heroImage && button.dataset.variantImage) {
          heroImage.src = button.dataset.variantImage;
          heroImage.alt = `${title} ${root.dataset.productName}`;
        }
        root.dataset.selectedVariantId = id;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url);
      }

      options.forEach((button) => button.addEventListener('click', () => selectVariant(button)));
      async function addSelected(button) {
        if (!mainForm || button.disabled) return;
        const originalLabel = button.textContent;
        buyButtons.forEach((buyButton) => { buyButton.disabled = true; });
        button.textContent = 'Adding…';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(mainForm),
          });
          if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
          window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
        } catch (error) {
          console.error('Unable to add the selected light to cart.', error);
          button.textContent = 'Try again';
          buyButtons.forEach((buyButton) => { buyButton.disabled = false; });
          window.setTimeout(() => { button.textContent = originalLabel; }, 2500);
        }
      }

      root.querySelectorAll('[data-submit-product]').forEach((button) => {
        button.addEventListener('click', () => addSelected(button));
      });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPocketLight, { once: true });
      } else {
        initPocketLight();
      }
    })();
